import React, { FC, useCallback, useEffect, useState } from 'react'
import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  Link,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  useToast
} from '@chakra-ui/react'

import { AiOutlineDelete, AiOutlineUser } from 'react-icons/ai'
import { RiAddLine, RiFilter2Fill, RiLockPasswordLine, RiPencilLine } from 'react-icons/ri'
import { AlertDialogCustom } from '../../Components/AlertDialog'
import { FloatMenuCustom } from '../../Components/Form/FloatMenuCustom'
import { Header } from '../../Components/Header'
import { SearchBox } from '../../Components/Header/SearchBox'
import { Pagination } from '../../Components/Pagination'
import { Sidebar } from '../../Components/Sidebar'
import api from '../../Services/api'
import { IUserProps } from '../../interfaces/IUserProps'
import { FilterUsersModal } from '../../Components/Modals/FilterUsersModal'
import { IPropertiesProps } from '../../interfaces/IPropertiesProps'
import { USERS_TYPE } from '../../Services/contants'



const UsersList: FC = () => {
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [data, setData] = useState<IUserProps[]>([])
  const [error, setError] = useState(false)
  const [total, setTotal] = useState(10)
  const [selectedItem, setSelectedItem] = useState({} as IUserProps)
  const [userToResetPassword, setUserToResetPassword] = useState({} as IUserProps)
  const [showModalFilter, setShowModalFilter] = useState(false)
  const [houseFiltered, setHouseFiltered] = useState<string[]>([])
  const [houses, setHouses] = useState<IPropertiesProps[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const toast = useToast()

  const isWideScreen = useBreakpointValue({
    base: false,
    lg: true
  })

  const loadProperties = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await api.get('/properties', {
        params: {
          pag: 1,
          all: true
        }
      })

      setHouses(data?.data)
      setHouseFiltered(data?.data?.map((i: any) => i.id))
    } catch (error) {
      console.log('erro ao pegar reservas: ', error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, [])

  const load = useCallback(async ({ page, search, properties }: { page: number; search?: string; properties?: string[] }) => {
    setLoading(true)
    try {
      console.log('load search: ', search)
      const { data } = await api.get('/users', {
        params: {
          pag: page,
          name: search,
          active: [0, 1],
          property_id: properties
        }
      })

      const normalize = data.data.map((i: IUserProps) => {
        // const regExpPhone = new RegExp(/^(\d{2})\D*(\d{5}|\d{4})\D*(\d{4})$/);
        return {
          ...i,
          phone: i?.phone || 'Não informado',
          createdAt: new Date(i.created_at).toLocaleString('pt-BR', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
          })
        }
      })

      setPage(page)
      setData(normalize)
      setTotal(data.total)
    } catch (error) {
      console.log('erro ao pegar users: ', error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, [])

  const handleForceResetPassword = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await api.post('/users/force-reset-password', {
        userId: userToResetPassword.id
      })

      toast({
        title: 'Senha resetada com sucesso',
        position: 'top',
        isClosable: true,
        status: 'success',
        variant: 'solid'
      })
      setUserToResetPassword({} as IUserProps)
      
    } catch (error) {
      toast({
        title: error.response.data.message,
        position: 'top',
        isClosable: true,
        status: 'error',
        variant: 'solid'
      })
    } finally {
      setLoading(false)
    }
  }, [userToResetPassword, toast])

  useEffect(() => {
    void load({ page, search: searchTerm, properties: houseFiltered })
  }, [page, load, searchTerm, houseFiltered])

  const hanleDelete = useCallback(async () => {
    const { id } = selectedItem
    try {
      await api.delete(`/users/${id}`)

      toast({
        title: 'Deletado com sucesso',
        position: 'top',
        isClosable: true,
        status: 'success',
        variant: 'solid'
      })
      setSelectedItem({} as IUserProps)
      load({ page, search: searchTerm, properties: houseFiltered })
    } catch (error) {
      toast({
        title: error.response.data.message,
        position: 'top',
        isClosable: true,
        status: 'error',
        variant: 'solid'
      })
      setSelectedItem({} as IUserProps)
    }
  }, [selectedItem, toast, page, load, searchTerm, houseFiltered])

  const closeModal = useCallback(() => {
    setSelectedItem({} as IUserProps)
    setUserToResetPassword({} as IUserProps)
  }, [])

  const handleApplyFilters = useCallback(async ({ houses }: { houses: string[] }) => {
    setHouseFiltered(houses || [])
    setPage(1)
    load({ page: 1, search: searchTerm, properties: houses })
  }, [load, searchTerm])


  useEffect(() => {
    loadProperties()
  }, [])

  const getUserType = useCallback((type: string) => {
    if(type === USERS_TYPE.HOMES) {
      return 'HOMES'
    } else if(type === USERS_TYPE.CLUB) {
      return 'CLUB'
    } else if(type === USERS_TYPE.HOMESCLUB) {
      return 'HOMES e CLUB'
    }
    return 'Nenhum tipo atribuído'
  }, [])

  return (
    <Box>
      {!!selectedItem?.id && (
        <AlertDialogCustom
          title="Deletar Usuário"
          isOpen={!!selectedItem?.id}
          cancelFunction={closeModal}
          nextFunction={hanleDelete}
        />
      )}

      {!!userToResetPassword?.id && (
        <AlertDialogCustom
          title="Resetar Senha"
          isOpen={!!userToResetPassword?.id}
          cancelFunction={closeModal}
          nextFunction={handleForceResetPassword}
        />
      )}

{showModalFilter && <FilterUsersModal open={showModalFilter} setOpen={() => setShowModalFilter(false)} houses={houses} onClose={() => setShowModalFilter(false)} onSubmit={handleApplyFilters} houseFiltered={houseFiltered}  />}

      <Header />

      <Flex w="100%" my="6" maxWidth={1480} mx="auto" px={['4', '4', '6']}>
        <Sidebar />

        <Box flex="1" borderRadius={8} bg="white" p="8">
          <Flex mb="8" justify="space-between" align="center">
            <Heading size="lg" fontWeight="normal" color="blue.500">
              Usuários
              {/* { !loading && isRefetching && <Spinner size="sm" ml="4" color="pink.400" />} */}
            </Heading>
            <SearchBox 
              placeholder="Buscar por nome" 
              onSearch={async (data) => {
                setSearchTerm(data.search)
                setPage(1)
                await load({ page: 1, search: data.search, properties: houseFiltered })
              }} 
            />

            {/* <Button
              as="a"
              size="sm"
              fontSize="sm"
              bg="blue.500"
              _hover={{ bgColor: "gray.500" }}
              color="white"
              leftIcon={<Icon as={RiAddLine} fontSize="20" />}
            >
              Criar novo usuário
            </Button> */}

            <Flex gap="2">
            <Button
                          onClick={() => setShowModalFilter(true)}
                          size="sm"
                          fontSize="sm"
                          bg="green.dark"
                          _hover={{ bgColor: 'green.light' }}
                          color="white"
                          leftIcon={<Icon as={RiFilter2Fill} fontSize="20" />}
                        >
                          Filtros
                      </Button>

                      <Button
              as="a"
              href="/users/create"
              size="sm"
              fontSize="sm"
              bg="green.dark"
              _hover={{ bgColor: 'green.light' }}
              color="white"
              leftIcon={<Icon as={RiAddLine} fontSize="20" />}
            >
              Criar Cliente
            </Button>

            </Flex>

            
          </Flex>

          {loading ? (
            <Flex justify="center">
              <Spinner />
            </Flex>
          ) : error ? (
            <Flex justify="center">
              <Text>Erro ao carregar a lista de usuários</Text>
            </Flex>
          ) : (
            <>
              <Table colorScheme="blue">
                <Thead>
                  <Tr>
                    {/* <Th px={["4","4","6"]} color="gray.300" w="8">
                                        <Checkbox colorScheme="pink" />
                                    </Th> */}
                    <Th>Usuário</Th>
                    <Th>Club</Th>
                    <Th>Fone</Th>
                    <Th w="6" align="center">Ações</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data.map((i) => (
                    <Tr key={i.id}>
                      {/* <Td px={["4","4","6"]}>
                                         <Checkbox colorScheme="pink" />
                                     </Td> */}
                      <Td>
                        <Box>
                          <Link color="blue.500">
                            <Text fontWeight="bold">{i.name}</Text>
                          </Link>
                          <Text fontSize="sm" color="gray.300">
                            {i.email}
                          </Text>
                        </Box>
                      </Td>
                      <Td>
                        <Text fontSize="sm" color="gray.300">
                            {getUserType(i.type)}
                          </Text>
                      </Td>
                      {isWideScreen && <Td color="blue.500">{i.phone}</Td>}
                      <Td>
                        <FloatMenuCustom
                          options={[
                            {
                              title: "Resetar Senha",
                              icon: <Icon as={RiLockPasswordLine} fontSize="16" />,
                              onClick: () => setUserToResetPassword(i)
                            },
                            {
                              title: "Visualizar",
                              icon: <Icon as={RiPencilLine} fontSize="16" />,
                              onClick: () => window.location.href = `/users/create/${i.id}`
                            },
                            {
                              title: "Excluir",
                              icon: <Icon as={AiOutlineDelete} fontSize="16" />,
                              onClick: () => setSelectedItem(i),
                              titleColor: "red.500"
                            }
                          ]}
                          menuPosition="right"
                        />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>

              <Pagination
                totalCountOfRegisters={total}
                totalPages={total}
                currentPage={page}
                onPageChange={setPage}
              />
            </>
          )}
        </Box>
      </Flex>
    </Box>
  )
}

export { UsersList }
